import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import {
  SIGNOUT,
  UPDATE_USER,
  RECEIVE_MANAGED_SOUNDCASTS,
  UPDATE_MANAGED_SOUNDCAST,
  MANAGED_SOUNDCASTS_STATUS,
} from '../actions/types';
import { default as order } from './order';

// contains all the soundcasts with their data in object form with soundcastId as keys
const byId = handleActions(
  {
    [RECEIVE_MANAGED_SOUNDCASTS]: (_, { payload }) => payload,
    [UPDATE_MANAGED_SOUNDCAST]: (state, { payload }) =>
      isEmpty(payload) ? {} : merge({}, omit(state, Object.keys(payload)), payload),
    [SIGNOUT]: () => ({}),
  },
  {}
);

// contains all the keys of a soundcast, for querying purposes
const allId = handleActions(
  {
    [RECEIVE_MANAGED_SOUNDCASTS]: (_, { payload }) => Object.keys(payload),
    [SIGNOUT]: () => [],
  },
  []
);

// when a list of soundcasts has been loaded (without the data)
const loaded = handleActions(
  {
    [UPDATE_USER]: () => false,
    [RECEIVE_MANAGED_SOUNDCASTS]: () => true,
  },
  false
);

// when each of soundcasts data are being requested or start to change
const busy = handleActions(
  {
    [RECEIVE_MANAGED_SOUNDCASTS]: (_, { payload }) => !isEmpty(payload),
    [MANAGED_SOUNDCASTS_STATUS]: (_, { payload }) => payload !== 'complete',
  },
  false
);

// when the soundcast list is completely empty
const empty = handleActions(
  {
    [RECEIVE_MANAGED_SOUNDCASTS]: (_, { payload }) => isEmpty(payload),
    [UPDATE_MANAGED_SOUNDCAST]: () => false,
  },
  true
);

// when all the data of all the soundcasts has been loaded
const complete = handleActions(
  {
    [MANAGED_SOUNDCASTS_STATUS]: (_, { payload }) => payload === 'complete',
  },
  false
);

export default combineReducers({ byId, allId, busy, empty, loaded, complete, order });
